/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Success_ContactInputs */

const en_company_registration_success_contact = /** @type {(inputs: Company_Registration_Success_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For questions, please contact info@ics-rm.de`)
};

const de_company_registration_success_contact = /** @type {(inputs: Company_Registration_Success_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Fragen melden Sie sich bitte unter info@ics-rm.de`)
};

/**
* | output |
* | --- |
* | "For questions, please contact info@ics-rm.de" |
*
* @param {Company_Registration_Success_ContactInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_success_contact = /** @type {((inputs?: Company_Registration_Success_ContactInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Success_ContactInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_success_contact(inputs)
	return en_company_registration_success_contact(inputs)
});